import { TabsList, TabsRoot, TabsTab } from "@gigpro/ui/Tabs";
import { Link, Outlet, useLocation } from "@tanstack/react-router";
import { ShiftsLayout } from "layouts/ShiftsLayout";

const TABS = [
  { value: "/admin/task-ops/interested-users", label: "Interested Users" },
  { value: "/admin/task-ops/participants", label: "Participants" },
  { value: "/admin/task-ops/uploads", label: "Uploads & Payouts" },
] as const;

function resolveActiveTab(pathname: string): (typeof TABS)[number]["value"] {
  if (pathname.startsWith("/admin/task-ops/interested-users")) return "/admin/task-ops/interested-users";
  if (pathname.startsWith("/admin/task-ops/uploads")) return "/admin/task-ops/uploads";
  return "/admin/task-ops/participants";
}

export function TaskOpsLayout() {
  const { pathname } = useLocation();
  const activeTab = resolveActiveTab(pathname);

  return (
    <ShiftsLayout title="Task Ops" hideDefaultHeader>
      <div className="flex flex-1 flex-col bg-white">
        <TabsRoot value={activeTab} variant="filled" className="px-4 pt-3">
          <TabsList>
            {TABS.map((tab) => (
              <TabsTab key={tab.value} value={tab.value} asChild>
                <Link to={tab.value}>{tab.label}</Link>
              </TabsTab>
            ))}
          </TabsList>
        </TabsRoot>
        <Outlet />
      </div>
    </ShiftsLayout>
  );
}
